import React from 'react';
import Icon from '../../../components/AppIcon';

const EngagementMetrics = ({ analytics, dateRange }) => {
  // Real data from analytics prop - default to 0 values
  const engagementData = {
    totalUsers: 0,
    activeUsers: 0,
    avgSessionDuration: '0m 0s',
    bounceRate: '0%',
    pageViews: 0,
    conversionRate: '0%'
  };

  const metrics = [
    { label: 'Total Users', value: engagementData?.totalUsers?.toLocaleString(), icon: 'Users', color: 'text-primary', change: '0%' },
    { label: 'Active Users', value: engagementData?.activeUsers?.toLocaleString(), icon: 'UserCheck', color: 'text-success', change: '0%' },
    { label: 'Avg Session', value: engagementData?.avgSessionDuration, icon: 'Clock', color: 'text-warning', change: '0%' },
    { label: 'Bounce Rate', value: engagementData?.bounceRate, icon: 'TrendingDown', color: 'text-error', change: '0%' },
    { label: 'Page Views', value: engagementData?.pageViews?.toLocaleString(), icon: 'Eye', color: 'text-primary', change: '0%' },
    { label: 'Conversion Rate', value: engagementData?.conversionRate, icon: 'Target', color: 'text-success', change: '0%' }
  ];

  const topPages = [];

  const conversionFunnel = [];

  return (
    <div className="space-y-6">
      {/* Key Metrics Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {metrics?.map((metric) => (
          <div key={metric?.label} className="bg-background border border-border rounded-xl p-4">
            <div className="flex items-center justify-between mb-2">
              <Icon name={metric?.icon} size={20} className={metric?.color} />
              <span className="text-xs font-semibold text-muted-foreground">
                {metric?.change}
              </span>
            </div>
            <div className="text-2xl font-bold text-foreground mb-1">{metric?.value}</div>
            <div className="text-xs text-muted-foreground">{metric?.label}</div>
          </div>
        ))}
      </div>

      {/* Conversion Funnel */}
      <div className="bg-background border border-border rounded-xl p-6">
        <div className="flex items-center gap-3 mb-6">
          <Icon name="Filter" size={24} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-foreground">Conversion Funnel</h3>
        </div>
        <div className="p-12 text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
            <Icon name="Filter" size={32} color="var(--color-muted-foreground)" />
          </div>
          <p className="text-muted-foreground">No conversion data yet</p>
          <p className="text-sm text-muted-foreground mt-2">Conversion funnel will appear as users progress through stages</p>
        </div>
      </div>

      {/* Top Pages */}
      <div className="bg-background border border-border rounded-xl p-6">
        <div className="flex items-center gap-3 mb-6">
          <Icon name="BarChart3" size={24} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-foreground">Top Performing Pages</h3>
        </div>
        <div className="p-12 text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
            <Icon name="BarChart3" size={32} color="var(--color-muted-foreground)" />
          </div>
          <p className="text-muted-foreground">No page data yet</p>
          <p className="text-sm text-muted-foreground mt-2">Page performance metrics will appear here</p>
        </div>
      </div>

      {/* User Behavior Heatmap */}
      <div className="bg-background border border-border rounded-xl p-6">
        <div className="flex items-center gap-3 mb-6">
          <Icon name="Activity" size={24} color="var(--color-primary)" />
          <h3 className="text-lg font-semibold text-foreground">User Interaction Heatmap</h3>
        </div>
        <div className="p-12 text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
            <Icon name="Activity" size={32} color="var(--color-muted-foreground)" />
          </div>
          <p className="text-muted-foreground">No interaction data yet</p>
          <p className="text-sm text-muted-foreground mt-2">User engagement heatmap will display here</p>
        </div>
      </div>
    </div>
  );
};

export default EngagementMetrics;